/* eslint-disable camelcase */
import api from './axios'

export interface Review {
  id: number
  name: string
  rating: number
  title: string
  message: string
  detail: string
  status: 'published' | 'hidden'
  created_at: string
}

export interface ReviewListResponse {
  data: Review[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export interface CreateReviewPayload {
  name: string
  rating: number
  title?: string
  message: string
  detail?: string
}

export interface UpdateReviewPayload {
  name?: string
  rating?: number
  title?: string
  message?: string
  detail?: string
  status?: 'published' | 'hidden'
}

export const reviewsApi = {
  // ── Public ────────────────────────────────────────────────────────────────
  list (params: { page?: number; limit?: number } = {}) {
    return api.get<ReviewListResponse>('/reviews', { params })
  },

  create (payload: CreateReviewPayload) {
    return api.post<Review>('/reviews', payload)
  },

  // ── Admin ─────────────────────────────────────────────────────────────────
  adminList (params: { page?: number; limit?: number; search?: string; rating?: number } = {}) {
    return api.get<ReviewListResponse>('/admin/reviews', { params })
  },

  adminUpdate (id: number, payload: UpdateReviewPayload) {
    return api.put<Review>(`/admin/reviews/${id}`, payload)
  },

  adminDelete (id: number) {
    return api.delete<{ message: string }>(`/admin/reviews/${id}`)
  }
}
